import { NetlogHttpClient } from 'lib/http';
import { FileAttachment } from 'models';
import { AttachmentHandler, FileId } from './attachment-handler';
import { ToastService } from 'services/toast-service';

export type MooringOfferDocumentsHandlerArgs = {
  mooringOfferId: number;
};

export class MooringOfferDocumentsHandler implements AttachmentHandler {
  private _mooringOfferId: number;

  constructor(private client: NetlogHttpClient, args: MooringOfferDocumentsHandlerArgs, private toastService: ToastService) {
    this._mooringOfferId = args.mooringOfferId;
  }

  set mooringId(id: number) {
    this.mooringId = id;
  }

  get baseUrl() {
    return `api/mooring-offers/${this._mooringOfferId}/attachments`;
  }

  async upload(file: File) {
    const attachemnts = await this.client.get<FileAttachment[]>({
      url: `api/mooring-offers/${this._mooringOfferId}/attachments`,
      model: FileAttachment,
    });

    if (attachemnts.data.length > 4) {
      this.toastService.showWarning('general.maxFiveAttachemntsWarning');
    } else {
      const form = this.client.fileFormdata(file);
      return this.client.uploadFile(form, this.baseUrl);
    }
  }

  delete(storageFileId: FileId) {
    return this.client.delete({
      url: `${this.baseUrl}/${storageFileId}`,
    });
  }

  download(storageFileId: FileId) {
    return this.client.downloadBlob(`api/system-storage/${storageFileId}`);
  }

  async metadata() {
    const response = await this.client.get<FileAttachment[]>(
      {
        url: `api/mooring-offers/${this._mooringOfferId}/attachments`,
        model: FileAttachment,
      },
      { cache: false }
    );
    return response.data;
  }
}
